import { ReactComponent as BarChartEmptyState } from '../images/BarChartEmptyState.svg'
import { ThemedSVGImage } from '../ThemedSVGImage'

export function EmptyBarChart() {
  return <ThemedSVGImage divProps={{ style: {} }} image={BarChartEmptyState} />
}
